const imagePaths = {
    iconPortafolio: "../images/Mi_Portafolio.png",
    selfie: "../images/Selfie.png",
    sistemaDeAsistenciaWeb: "../images/Sistema_de_Asistencia.png",
    sistemaDeAsistenciaEscritorio: "../images/Sistema_de_Asistencia_Escritorio.png",
    filaVirtualUsuario: "../images/Fila_Virtual.png",
    filaVirtualAgente: "../images/Fila_Virtual_Agente.png",
    filaVirtualAdministrador: "../images/Fila_Virtual_Administrador.png",
    lectorMRZ: "../images/Lector_MRZ.png",
    registroDeIncidencias: "../images/Registro_de_Incidencias.png",
    EmpleosInclusivos: "../images/Empleos_Inclusivos.png",
}

export default imagePaths